import React from 'react';
import styles from './TasksHeader.module.scss';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
interface TasksHeaderProps {
  isLoading: boolean;
}

const TasksHeader: React.FC<TasksHeaderProps> = ({ isLoading }) => {
  return (
    <div
      className={`${styles.tasksHeader} ${isLoading ? styles.tasksHeader_loading : ''}`}
    >
      <div className={styles.tasksHeader__content}>
        <div className={styles.tasksHeader__title}>Выполняй задания</div>
        <div className={styles.subtitle}>
          и получай звёзды за рекламу, клики и подписки.
        </div>
      </div>
    </div>
  );
};

export default TasksHeader;
